export default __webpack_public_path__ + "static/media/attachment-without-bike.69419321.jpg";